import styles from './DesktopWrapper.module.scss';

import React from 'react';

export const DesktopWrapper: React.FC = (props) => {
  return <div className={styles['desktop-wrapper']}>{props.children}</div>;
};
